import React, { useContext, useEffect, useState } from 'react';
import { LoaderContext } from '../../../contexts/loaderContext.js';
import { AgGridReact } from 'ag-grid-react';
import { ZoomContext } from '../../../contexts/zoomContext.js';
import { defaultColumnDef, getChatHistoryColumns, SECOND_TAB_TABLE_HEADER } from '../aiAnalyticsHelpers.js';
import { DEFAULT_PAGINATION_PAGE_SIZE, paginationPanel, theme, TOOLTIP_SHOW_DELAY } from '../../System/AgGrid/RegisterAgGridModules.js';
import { ForgeDivider } from '@tylertech/forge-react';
import '../AiAnalytics.scss';
import { getChatHistory, getQuestionAnswer } from '../../../services/aiAnalyticsService.js';
import PropTypes from 'prop-types';
import ViewQuestionDataModal from './ViewQuestionDataModal.js';

const ChatHistoryTab = ({ timePeriod }) => {
  const [pageSize, setPageSize] = useState(DEFAULT_PAGINATION_PAGE_SIZE);
  const [tableData, setTableData] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  
  const { setLoading } = useContext(LoaderContext);
  const { autoHeight, gridRef } = useContext(ZoomContext);

  const onCloseModal = () => setModalData(null);

  const prepare = () => {

    getChatHistory(timePeriod.value).then(resp => {
      const data = resp.data;

      setTableData(data);
      setTotalCount(data.length);
      setLoading(false);
    });

  };

  const onReviewQuestion = (params) => {
    getQuestionAnswer(params.id, params.organizationName).then(resp => {
      setModalData(resp.data);
    });
  };

  useEffect(() => {
    prepare();
  }, [timePeriod]);

  return (
    <>
      <div className="dataContainer flexContainer direction-column noWrap">
        <div className="padding marginTop">
          <span className="forge-typography--subheading5">{SECOND_TAB_TABLE_HEADER}</span>
        </div>
        <ForgeDivider style={{ width: '100%' }} />
        <div className="pbbStrategistTableContainer">
          <AgGridReact
            theme={theme}
            ref={gridRef}
            defaultColDef={defaultColumnDef}
            columnDefs={getChatHistoryColumns(onReviewQuestion)}
            rowData={tableData}
            animateRows={false}
            tooltipShowMode={'whenTruncated'}
            onFilterChanged={(params) => {
              setTotalCount(params.api.paginationGetRowCount());
              params.api.paginationGoToPage(0);
            }}
            tooltipShowDelay={TOOLTIP_SHOW_DELAY}
            suppressCellFocus={true}
            pagination={true}
            suppressPaginationPanel={true}
            paginationPageSize={pageSize}
            statusBar={paginationPanel(gridRef, totalCount, setPageSize, pageSize)}
            domLayout={autoHeight ? 'autoHeight' : 'normal'}
          />
        </div>
      </div>
      {Boolean(modalData) &&
        <ViewQuestionDataModal open={Boolean(modalData)} data={modalData} onClose={onCloseModal} />
      }
    </>
  );
};

export default ChatHistoryTab;

ChatHistoryTab.propTypes = {
  timePeriod: PropTypes.object
};
